export default __webpack_public_path__ + "static/media/808.a614ca63.png";